import React from 'react';


export default () => (
    <div className="movie-details-page__loader"/>
)



// WEBPACK FOOTER //
// ./js/movies/components/Loader.jsx